import { NgModule, Pipe, PipeTransform } from '@angular/core';

/**
 * Vendored verbatim from the abandoned `ng2-search-filter@0.5.1` (last published 2019, View-Engine
 * format). Angular 16 removed ngcc, so the published package no longer compiles ("Ng2SearchPipeModule
 * does not appear to be an NgModule class"). The logic below is copied byte-for-byte from the package's
 * compiled output to preserve filtering behavior exactly. `@Injectable` was dropped (Ivy generates the
 * pipe factory, so a `providers: [Ng2SearchPipe]` registration remains injectable, and Ivy rejects a
 * combined @Pipe + @Injectable).
 */
@Pipe({
    name: 'filter',
    pure: false,
    standalone: false
})
export class Ng2SearchPipe implements PipeTransform {
    transform(items: any, term: string): any {
        if (!term || !items) {
            return items;
        }
        return Ng2SearchPipe.filter(items, term);
    }

    static filter(items: Array<{ [key: string]: any }>, term: string): Array<{ [key: string]: any }> {
        const toCompare = term.toLowerCase();

        function checkInside(item: any, term: string): boolean {
            for (const property in item) {
                if (item[property] === null || item[property] === undefined) {
                    continue;
                }
                if (typeof item[property] === 'object') {
                    if (checkInside(item[property], term)) {
                        return true;
                    }
                }
                if (item[property].toString().toLowerCase().includes(toCompare)) {
                    return true;
                }
            }
            return false;
        }

        return items.filter(function (item) {
            return checkInside(item, term);
        });
    }
}

@NgModule({
    declarations: [Ng2SearchPipe],
    exports: [Ng2SearchPipe]
})
export class Ng2SearchPipeModule { }
